import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { sessionSchemaOf, } from '@britania/teams-kit-core';
import { Button } from '@fluentui/react-components';
import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';
import { ApiError } from '#src/api/http-client.js';
import { useAppConfig } from '#src/app/app-config.js';
import { useApi, useAuth } from '#src/auth/AuthProvider.js';
import { StatusScreen } from '#src/shared/StatusScreen.js';
const SESSION_KEY = ['session'];
const FORBIDDEN = 403;
function useSessionQuery() {
    const api = useApi();
    const { permissions } = useAppConfig();
    return useQuery({
        queryKey: SESSION_KEY,
        // Com o catálogo da aplicação: uma chave que o frontend não conhece é erro.
        queryFn: () => api.get('/auth/me', sessionSchemaOf(permissions)),
    });
}
/**
 * Só renderiza a aplicação depois de saber quem entrou. Sem isto, um link
 * direto mostraria "sem acesso" antes de as permissões chegarem.
 */
export function SessionGate({ children }) {
    const session = useSessionQuery();
    const { signOut } = useAuth();
    if (session.isPending) {
        return _jsx(StatusScreen, { loading: true, title: "Entrando..." });
    }
    if (session.isError) {
        const blocked = session.error instanceof ApiError && session.error.status === FORBIDDEN;
        return (_jsx(StatusScreen, { tone: blocked ? 'denied' : 'error', title: blocked ? 'Acesso bloqueado' : 'Não foi possível entrar', description: session.error.message, action: _jsxs(_Fragment, { children: [_jsx(Button, { onClick: () => session.refetch(), children: "Tentar de novo" }), signOut && (_jsx(Button, { onClick: signOut, children: "Entrar com outro e-mail" }))] }) }));
    }
    return children;
}
/** Sessão de quem entrou. Só dentro do `SessionGate`, onde ela já existe. */
export function useSession() {
    const { data } = useSessionQuery();
    if (data === undefined) {
        throw new Error('useSession fora do SessionGate');
    }
    return data;
}
/**
 * Verificador de acesso. Sem permissão exigida, basta estar autenticado. A
 * decisão é do backend (as permissões vêm de `/auth/me`); aqui só se esconde
 * o que não seria liberado de qualquer forma.
 */
export function useAccess() {
    const { permissions } = useSession();
    return useCallback((permission) => permission === undefined || permissions.includes(permission), [permissions]);
}
//# sourceMappingURL=session.js.map